(function (window, document) {
	/* ---------------------------------------- [START] Table Layout */
	/* 將上稿區內的表格改為：
	 * 視第一橫列為標題，將標題生成於相對的子欄位
	 * 在手機板會破壞表格的排版
	 */
	function tableLayout() {
		var tables = document.querySelectorAll('#article-cont table');

		if (!tables.length) {
			return false;
		}

		// ======================================== [START] Wrap & Scroll
		var scrollArea; // 紀錄 ScrollArea
		var tableWrap = function () {

			// 重新取得表格物件們（排除指定項目）
			var getTables = function () {
				return Array.from(tables).filter(function(el) {
					if (!el.dataset || el.dataset['wrap'] !== 'false') {
						return el
					} else {
						return false
					}
				});
			}

			tables = getTables();

			[].forEach.call(tables, function (table, i) {

				var wrapper = document.createElement('div');
				wrapper.className = 'table-wrapper is-scroll-start';

				var scrollArea = document.createElement('div');
				scrollArea.className = 'table-wrapper__scroll-area';

				scrollArea.addEventListener('scroll', scrollAreaDetected);
				wrap(table, scrollArea);
				wrap(scrollArea, wrapper);
			});

			// 讀取 ScrollArea 物件
			scrollArea = document.querySelectorAll('#article-cont .table-wrapper__scroll-area');

			// 監測 Resize
			scrollDetected();
			window.addEventListener('resize', throttle(scrollDetected, 50, 100));
		};
		tableWrap();

		// Resize All
		function scrollDetected() {
			[].forEach.call(scrollArea, function (item) {
				scrollAreaResize(item, item.parentElement);
			});
		}

		// Resize
		function scrollAreaResize(currentScrollArea, detectEl) {
			if (checkHasScroll(currentScrollArea)) {
				detectEl.classList.add('has-scroll');
			} else {
				detectEl.classList.remove('has-scroll');
			}
			scrollAreaDetected(currentScrollArea);
		}

		// Scroll 監測
		function scrollAreaDetected(target) {
			var self = target.tagName ? target : this;
			var targetWrapper = self.parentElement;

			// Scroll Start
			if (self.scrollLeft === 0) {
				targetWrapper.classList.add('is-scroll-start');
			} else {
				targetWrapper.classList.remove('is-scroll-start');
			}

			// Scroll End
			if (self.scrollLeft + self.clientWidth === self.scrollWidth) {
				targetWrapper.classList.add('is-scroll-end');
			} else {
				targetWrapper.classList.remove('is-scroll-end');
			}
		}

		// Tool
		// Ref: https://stackoverflow.com/a/18453767/11240898
		function wrap(toWrap, wrapper) {
			wrapper = wrapper || document.createElement('div');
			// 因為 toWrap 可能不是最後一個物件，建議將「appendChild」改為「insertBefore」方式（該篇有他人留言建議）
			toWrap.parentNode.insertBefore(wrapper, toWrap);
			return wrapper.appendChild(toWrap);
		}

		function checkHasScroll(el) {
			return el.scrollWidth > el.clientWidth;
		}
		// ======================================== [END] Wrap & Scroll
	}
	window.addEventListener('load', tableLayout);
	/* ---------------------------------------- [END] Table Layout */
})(window, document);
